export const HIT_ACTUALIZE_PRICE_CHANGE = 'HIT_ACTUALIZE_PRICE_CHANGE';
